import React from 'react';

class PlayPauseButton extends React.Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    event.stopPropagation();
    event.preventDefault();
    if (this.props.video.paused) {
      const playPromise = this.props.video.play();
      if (playPromise) playPromise.catch(() => {});
    } else {
      this.props.video.pause();
    }
  }

  render() {
    var classes = 'b-playpause';
    if (this.props.paused) {
      classes += ' paused';
    }
    return <div className={classes} onClick={this.onClick} onTouchEnd={this.onClick}></div>;
  }
}

export default PlayPauseButton;
